import { render, staticRenderFns } from "./VasomotorRhinitis.vue?vue&type=template&id=291efece"
import script from "./VasomotorRhinitis.vue?vue&type=script&lang=js"
export * from "./VasomotorRhinitis.vue?vue&type=script&lang=js"
import style0 from "./VasomotorRhinitis.vue?vue&type=style&index=0&id=291efece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports